/// <amd-module name="Build/Admin/Common/Sources/JobSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { TaskAgentJobRequest, TaskAgentPoolMaintenanceJob } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

import { TaskAgentJobsData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { DataProviders } from "Build/Admin/Common/Constants";

export class JobSource {
    private _client: ITaskAgentRestClient;
    private _jobsData: TaskAgentJobsData | undefined;

    constructor(pageContext: IVssPageContext) {
        this._client = getTaskAgentClient(pageContext);
        const contributionService: IVssContributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._jobsData = contributionService.getData<TaskAgentJobsData>(DataProviders.Jobs);
    }

    public getCachedJobs(): TaskAgentJobRequest[] {
        if (this._jobsData && this._jobsData.jobs) {
            return this._jobsData.jobs;
        }
        else {
            return [];
        }
    }

    public async getAgentPoolJobs(taskAgentPoolId: number, top: number, continuationToken?: string): Promise<TaskAgentJobRequest[]> {
        return this._client.getAgentRequests(taskAgentPoolId, top, continuationToken);
    }

    public async getAgentPoolMaintenanceJobs(taskAgentPoolId: number): Promise<TaskAgentPoolMaintenanceJob[]> {
        return this._client.getAgentPoolMaintenanceJobs(taskAgentPoolId);
    }

    public async getAgentPoolJobsForAgent(taskAgentPoolId: number, taskAgentId: number, completedRequestCount: number): Promise<TaskAgentJobRequest[]> {
        return this._client.getAgentRequestsForAgent(taskAgentPoolId, taskAgentId, completedRequestCount);
    }

    public async getAgentRequest(taskAgentPoolId: number, requestId: number, includeStatus: boolean): Promise<TaskAgentJobRequest> {
        return this._client.getAgentRequest(taskAgentPoolId, requestId, includeStatus);
    }

    public async queueMaintenanceJob(job: TaskAgentPoolMaintenanceJob, poolId: number): Promise<TaskAgentPoolMaintenanceJob> {
        return this._client.queueAgentPoolMaintenanceJob(job, poolId);
    }
}
